import { Route } from '@angular/router'
import { authGuard } from '@baboor/baboor-auth'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type NotificationRoutes = {
    notifications: Route
}

export const notificationRoutes: NotificationRoutes = {
    notifications: {
        path: 'dashboard/notifications',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-notifications/page-notifications.component').then(
                (m) => m.PageNotificationsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
